import { computed, ComputedRef } from "vue";
import { useRouter, useRoute } from "vue-router";

interface RouterUtils {
  buildHash: (text: string) => string;
  setHash: (text: string) => void;
  currentHash: ComputedRef<string>;
  isCurrentHash: (text: string) => boolean;
}

export default function useRouterHash(): RouterUtils {
  const router = useRouter();
  const route = useRoute();
  const currentHash = computed(() => route.hash);

  const buildHash = (text?: string | null) => (text ? `#${text}` : "");

  const isCurrentHash = (text?: string | null) => currentHash.value === buildHash(text);

  const setHash = (text?: string | null) => {
    const location = {
      ...route,
      hash: buildHash(text),
    };

    router.push(location);
  };

  return {
    buildHash,
    setHash,
    currentHash,
    isCurrentHash,
  };
}
